export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5345.cd9a00a4.jpg";